import type { Person } from '../../lib/peopleApi';
import { PersonCard } from './PersonCard';

interface PeopleGridProps {
  people: Person[];
}

export function PeopleGrid({ people }: PeopleGridProps) {
  if (people.length === 0) {
    return <p className="text-gray-500">Niciun membru al echipei nu corespunde filtrelor.</p>;
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {people.map((person) => (
        <PersonCard key={person.id} person={person} />
      ))}
    </div>
  );
}
